import { MultiSelectFacet } from "./components/facets/MultiSelectFacet";
import { SelectCategoryFacet } from "./components/facets/SelectCategoryFacet";
import { SelectProductFacet } from "./components/facets/SelectProductFacet";
import { SelectVersionFacet } from "./components/facets/SelectVersionFacet";
import { FilterOptionEnum, FilterTypeEnum, ServiceEnum } from "./models/dataModel";
const config = {
    endpoint: process.env.REACT_APP_ENVIRONMENT === "production"
        ? "https://search.trimble.com/api/v1.0/"
        : "https://stg.search.trimble.com/api/v1.0/",
    services: {
        [ServiceEnum.TRIMBLE_HELP]: {
            categoryName: "Trimble Help",
            facetList: [
                {
                    field: FilterOptionEnum.PRODUCT,
                    filterType: FilterTypeEnum.ALL,
                    label: `facets.${FilterOptionEnum.PRODUCT}`,
                    view: SelectProductFacet,
                },
                {
                    field: FilterOptionEnum.VERSION,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.VERSION}`,
                    view: SelectVersionFacet,
                },
                {
                    field: FilterOptionEnum.AREA,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.AREA}`,
                    view: MultiSelectFacet,
                },
                {
                    field: FilterOptionEnum.CONTENT_AREA,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.CONTENT_AREA}`,
                    view: MultiSelectFacet,
                },
                {
                    field: FilterOptionEnum.TYPE,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.TYPE}`,
                    view: MultiSelectFacet,
                },
                {
                    field: FilterOptionEnum.INFORMATION_TYPE,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.INFORMATION_TYPE}`,
                    view: MultiSelectFacet,
                },
                {
                    field: FilterOptionEnum.ENVIRONMENT,
                    filterType: FilterTypeEnum.ANY,
                    label: `facets.${FilterOptionEnum.ENVIRONMENT}`,
                    view: MultiSelectFacet,
                },
                {
                    field: FilterOptionEnum.DEVICE,
                    filterType: FilterTypeEnum.ALL,
                    label: `facets.${FilterOptionEnum.DEVICE}`,
                    view: MultiSelectFacet,
                }
            ],
            filters: [
                FilterOptionEnum.PRODUCT,
                FilterOptionEnum.VERSION,
                FilterOptionEnum.AREA,
                FilterOptionEnum.CONTENT_AREA,
                FilterOptionEnum.TYPE,
                FilterOptionEnum.INFORMATION_TYPE,
                FilterOptionEnum.ENVIRONMENT,
                FilterOptionEnum.DEVICE,
            ],
            resultFields: [
                "id",
                "url",
                "title",
                "teaser",
                // "tags",
                FilterOptionEnum.PRODUCT,
                FilterOptionEnum.VERSION,
                FilterOptionEnum.AREA,
                FilterOptionEnum.CONTENT_AREA,
                FilterOptionEnum.TYPE,
                FilterOptionEnum.INFORMATION_TYPE,
                FilterOptionEnum.ENVIRONMENT,
                FilterOptionEnum.DEVICE,
            ],
            tagsToDisplay: [
                FilterOptionEnum.PRODUCT,
                FilterOptionEnum.VERSION,
                FilterOptionEnum.TYPE,
                FilterOptionEnum.DEVICE,
                FilterOptionEnum.AREA,
                FilterOptionEnum.INFORMATION_TYPE,
                FilterOptionEnum.CONTENT_AREA,
                // FilterOptionEnum.ENVIRONMENT,
            ],
        },
    },
    global: {
        categoryName: "All Categories",
        facetList: [
            {
                field: FilterOptionEnum.CATEGORY,
                filterType: FilterTypeEnum.ALL,
                label: `facets.category`,
                view: SelectCategoryFacet,
            },
        ],
        filters: [FilterOptionEnum.CATEGORY],
        resultFields: ["id", "url", "title", "teaser", "content_type"],
    },
};
export default config;
